import * as React from 'react';
import { Check } from '@sravni/react-icons';
import { useStyles, noop } from '@sravni/react-utils';
import modules_173205eb from '../styles/Radio.module.less.js';

/**
 * @description Radio component.
 *
 * @component
 * @example
 * ```jsx
 * <Radio name="radio" value="default" label="Radio default" checked disabled />
 * ```
 */
const Radio = React.forwardRef((props, ref) => {
    const { name, value, checked, disabled, readOnly, className, children, onChange = noop, ...restProps } = props;
    const cx = useStyles(modules_173205eb);
    const classNames = cx(className, 'container', {
        checked,
        disabled,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'read-only': readOnly,
    });
    const controlClassNames = cx('control', {
        checked,
        disabled,
    });
    return (React.createElement("label", { "data-qa": "Radio", className: classNames },
        React.createElement("input", { ref: ref, className: cx('input'), type: "radio", name: name, value: value, checked: checked, disabled: disabled, onChange: onChange, ...restProps }),
        React.createElement("div", { className: controlClassNames }, checked ? React.createElement(Check, { className: cx('icon') }) : null),
        children ? React.createElement("span", { className: cx('label') }, children) : null));
});
Radio.defaultProps = {
    checked: false,
};
Radio.displayName = 'Radio';

export { Radio };
//# sourceMappingURL=Radio.js.map
